import { IDocument } from '../../../../../../models/document';
import DocumentsTableList from './DocumentTableList';

export default function DocumentsList({
  title,
  data,
  actions
}: {
  title: string;
  data: IDocument[];
  actions?: Array<{
    label: string;
    onClick: (document: IDocument) => void;
  }>;
}) {

  return (
    <div className="row">
      <div className="col-12 my-2">
        <div className="bg-light border rounded shadow h-100 mx-0 px-4 py-3">
          <div className="row py-2 border-bottom mb-2">
            <span className="text-uppercase fw-bold fs-5">{title}</span>
          </div>
          <div className="row flex-row">
            <DocumentsTableList
              data={data}
              actions={actions}
            />
          </div>
        </div>
      </div>
    </div>
  )
}